import React from 'react';
import UsersSwapHistory from "../components/UsersSwapHistory/UsersSwapHistory";

const AdminSwapHistory = () => {
  return <UsersSwapHistory />
}

export default AdminSwapHistory;